import { Skeleton } from '@/components/ui/skeleton';

// Full-pane skeleton shown while a lazy route chunk loads.
export function PageFallback() {
    return (
        <div className="flex h-full w-full flex-col gap-4 p-6" aria-busy="true">
            <div className="flex items-center justify-between">
                <Skeleton className="h-7 w-48 skeleton-shimmer" />
                <Skeleton className="h-9 w-32 skeleton-shimmer" />
            </div>
            <Skeleton className="h-4 w-72 skeleton-shimmer" />
            <div className="mt-2 flex flex-col gap-3">
                <Skeleton className="h-16 w-full skeleton-shimmer" />
                <Skeleton className="h-16 w-full skeleton-shimmer" />
                <Skeleton className="h-16 w-full skeleton-shimmer" />
                <Skeleton className="h-16 w-full skeleton-shimmer" />
            </div>
        </div>
    );
}
